/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../apimodel.d.ts" />
/// <reference path="app.common.controllers.module.ts" />
/// <reference path="../../common/iapirequestconfig.ts" />
/// <reference path="../messageboxconfig.ts" />

module App.Common.Controllers {
    'use strict';

    export class DocumentUploadController<T extends Hca.HiLO.ViewModel.IDocumentViewModel> extends ModalDialogControllerBase {

        public selectedFile: File;
        public documentId: string;
        public uploading = false;
        public uploadStarted = false;
        public uploadCompleted = false;
        public uploadProgress: number;
        public uploadPromise: angular.angularFileUpload.IUploadPromise<any>;
        public cancelled = false;
        public editMode = false;
        public showNotes = true;
        protected guid: Common.Services.GuidService;
        protected uploader: angular.angularFileUpload.IUploadService;

        public static $inject = [
            '$injector',
            '$uibModalInstance',
            'config',
            'modalConfig',
            '$uibModalStack'
        ];
        constructor(
            $injector: angular.auto.IInjectorService,
            $uibModalInstance: angular.ui.bootstrap.IModalServiceInstance,
            public config: DocumentUploadConfig<T>,
            modalConfig: ModalDialogConfig,
            $uibModalStack: angular.ui.bootstrap.IModalStackService
        ) {

            super($injector, $uibModalInstance, modalConfig, $uibModalStack);

            this.guid = $injector.get<Common.Services.GuidService>('app.common.services.guidService');
            this.uploader = $injector.get<angular.angularFileUpload.IUploadService>('Upload');

            if (!this.config.model) {
                this.config.model = {} as T;
            } else {
                this.documentId = this.config.model.id;
                this.editMode = true;
            }
        }

        public initialize(): angular.IPromise<any> {
            return this.$q.resolve();
        }

        private mbForBytes(valueInBytes): string {
            // This always gives us two dp
            // Want only significant figures down to 2 dp
            var mbWithTwoDp = (valueInBytes / Math.pow(1024, 2)).toFixed(2);
            var output = mbWithTwoDp;
            while (output[output.length - 1] === "0" && output.indexOf(".") > -1) {
                output = output.substring(0, output.length - 1);
                if (output[output.length - 1] === ".") {
                    output = output.substring(0, output.length - 1);
                    break;
                }
            }
            return output;
        }

        public mainFormName(): any {
            return 'documentUploadForm';
        }

        public upload(file: any) {
            this.userMessages.clear();
            if (!file) {
                this.userMessages.addMessage('Only files of type PDF that are less than ' + this.mbForBytes(this.globalSettings.maxFileUploadSize) + 'mb can be uploaded', Common.UserMessageType.Error);
            } else if (file.$error === 'maxSize' || file.size > this.globalSettings.maxFileUploadSize) {
                this.userMessages.addMessage(
                    'The max filesize is ' + this.mbForBytes(this.globalSettings.maxFileUploadSize) + 'mb and the file is ' + this.mbForBytes(file.size) + 'mb.',
                    Common.UserMessageType.Error);
            } else if (file.$error === 'pattern') {
                this.userMessages.addMessage('FILETYPE ERROR - CHANGE THIS MESSAGE', Common.UserMessageType.Error, false);
            } else if (file.$error) {
                this.userMessages.addMessage(file.$error, Common.UserMessageType.Error);
            }

            if (this.userMessages.messages.errorMessages.length> 0) {
                this.close();
                return;
            }

            this.documentId = this.documentId || this.guid.newGuid();

            var config = {
                url: `/api/${this.config.saveApiRequestConfig.resourceName}/Upload`,
                params: { id: this.documentId },
                data: {
                    file: this.selectedFile
                },
                headers: {} as angular.IHttpRequestConfigHeaders,
                method: 'POST'
            } as angular.angularFileUpload.IFileUploadConfigFile;

            this.api.addDefaultHeaders(config);
            this.api.addAuthHeaderWithToken(config);

            this.uploadStarted = true;
            this.uploading = true;
            this.uploadProgress = 0;

            this.uploadPromise = this.uploader.upload<any>(config);

            this.uploadPromise
                .then(() => {
                    this.uploading = false;
                    this.uploadCompleted = true;
                    this.config.model.filename = this.selectedFile.name;
                        this.config.model.id = this.documentId;
                    this.close();
                },
                (result: angular.IHttpPromiseCallbackArg<any>) => {
                    if (this.cancelled) { return this.$q.resolve(); }
                    if (result.status === 409) {
                        this.modal.messageBox('Virus Detected', 'The server detected a virus in the uploaded file. The file has not been uploaded.');
                        this.reset();

                        return this.$q.resolve();
                    } else {
                        return this.errorHandler.handleHttpError(result, false);
                    }

                },
                (progress: angular.angularFileUpload.IFileProgressEvent) => {
                    this.uploadProgress = Math.round(100.0 * progress.loaded / progress.total);
                });
        }

        public reset() {
            this.documentId = null;
            this.uploadStarted = false;
            this.uploading = false;
            this.uploadCompleted = false;
            this.selectedFile = null;
        }

        public canSave() {
            return this.editMode || (!!this.selectedFile && this.uploadCompleted);
        }

        public save() {
            this.documentId = this.documentId || this.guid.newGuid();

            this.config.model = this.config.model || {} as T;

            if (!this.editMode) {
                this.config.model.id = this.documentId;
                this.config.model.filename = this.selectedFile.name;
                this.config.model.fileLastModifiedDate = this.selectedFile.lastModifiedDate;
                this.config.model.size = this.selectedFile.size;
            }

            this.config.saveApiRequestConfig.data = this.config.model;

            this.api.post(this.config.saveApiRequestConfig).then(() => {
                this.close();
            });
        }

        public cancel() {
           
            this.close();


        }

    }

    angular
        .module('app.common.controllers')
        .controller('app.common.controllers.documentUploadController', DocumentUploadController);
}